<div class='position-relative' *ngIf="internalStatus.enabled">
<pt-widget-disabled
    *ngIf="internalStatus.viewMode === 'LOADING'"
    [showLoader]="internalStatus.viewMode === 'LOADING'">
  </pt-widget-disabled>

  <pt-widget-header
    [comment]="comment"
    [unsavedComment]="unsavedComment"
    (clickCommentWidget)='clickCommentWidget()'
    (clickCreateOpt)='createOptWidget()'
    (clickEditWidget)='dispatchEditState()'

    (clickReloadWidget)='reloadWidget(widget)'
    (clickResetWidget)='resetWidget(widget)'
    (clickSaveWidget)='saveWidget()'
    [disabledCancelButton]='internalStatus.disabledCancelButton'
    [disabledCommentButton]='internalStatus.disabledCommentButton'
    [disabledEditButton]='internalStatus.disabledEditButton'

    [disabledOptButton]='internalStatus.disabledOptButton'
    [disabledReloadButton]='internalStatus.disabledReloadButton'
    [disabledSaveButton]='internalStatus.disabledSaveButton'
    [help]='widget?.help'
    [label]='widget?.label'
    [loading]='internalStatus.isLoading'
    [showCancelButton]='internalStatus.showCancelButton'

    [showCommentButton]='internalStatus.showCommentButton'
    [showEditButton]='internalStatus.showEditButton'
    [showOptButton]='internalStatus.showOptButton'
    [showReloadButton]='internalStatus.showReloadButton'
    [showSaveButton]='internalStatus.showSaveButton'
    class='w-100'>
  </pt-widget-header>

  <ng-container *ngIf='!internalStatus.showOptButton'>

    <pt-wrc-v0-editor
      *ngIf="internalStatus.viewMode === 'EDIT'"
      [guaranteesRequired]="guaranteesRequired"
      [uniqueRecipient]="uniqueRecipient"
      [header]="editorData?.argsHeader"
      [recipientEntity]="editorData?.recipientEntity"
      [guarantees]="editorData?.argsData?.guarantees"
      [recipientType]="editorData?.argsData?.recipientType"
      [country]="editorData?.country"
      [value]="editorData?.value"
      (changeValue)="changeValue($event)">
    </pt-wrc-v0-editor>


<!--    <pt-widget-recipient-chooser-v0-edit-->
<!--      (changeValue)='changeValue($event)'-->
<!--      [data]='editorData'-->
<!--      [show]="internalStatus.viewMode === 'EDIT' || internalStatus.viewMode === 'LOADING'">-->
<!--    </pt-widget-recipient-chooser-v0-edit>-->

    <pt-widget-recipient-chooser-v0-preview
      *ngIf="internalStatus.viewMode === 'PREVIEW' || internalStatus.viewMode === 'LOADING'"
      [noDataLabel]="noDataLabel"
      [loading]='internalStatus.isLoading'
      [previewData]='previewData'>
    </pt-widget-recipient-chooser-v0-preview>

    <pt-widget-error
      *ngIf="internalStatus.viewMode === 'ERROR'"
      [errorMessage]='internalStatus.errorMessage | async'>
    </pt-widget-error>

    <pt-widget-footer>
    </pt-widget-footer>

  </ng-container>

</div>




